import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  computed: {
    showOverwriteMessage() {
      if (!this.lastModifiedData.lastModified) {
        return false
      }

      const editStartTime = Number(this.lastModifiedData.editStartTime)
      const lastModified = Number(this.lastModifiedData.lastModified)

      return editStartTime < lastModified
    },
    lastModifiedDuration() {
      const lastModified = Number(this.lastModifiedData.lastModified)
      const durationInSeconds = Math.floor(Date.now() / 1000) - lastModified

      return Math.floor(durationInSeconds / 60 + 1)
    }
  },
  methods: {
    checkLastEditedAndHandleSave() {
      this.isLaunching = true
      if (this.$route.query.id) {
        this.checkLastModifiedData()
      } else {
        this.handleSave()
      }
    },
    checkLastModifiedData() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `campaigns/${this.$route.query.id}`,
          params: {
            expand: ['last_modified', 'last_modifier'].join(','),
            for: 'vue'
          }
        })
      )
        .then(({ data }) => {
          this.lastModifiedData.lastModified = data.last_modified
          this.lastModifiedData.lastModifier = data.last_modifier
          if (this.showOverwriteMessage) {
            this.showOverwriteWarning()
          } else {
            this.handleSave()
          }
        })
        .catch(data => {
          if (data.message) {
            this.$message({
              message: data.message,
              type: 'error'
            })
          }
        })
    },
    showOverwriteWarning() {
      let overwriteMessage = this.$t(
        'CampaignForm_ReviewDialog_Overwrite_Changes_Message',
        {
          user: this.lastModifiedData.lastModifier.name,
          minutes: this.lastModifiedDuration,
          noun: this.lastModifiedDuration > 1 ? 'minutes' : 'minute'
        }
      )
      this.$confirm(overwriteMessage, '', {
        confirmButtonText: this.$t(
          'CampaignForm_ReviewDialog_Overwrite_Changes'
        ),
        cancelButtonText: this.$t('Campaign_Dialog_Button_Cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.handleSave()
        })
        .catch(() => {
          this.loading = false
        })
    },
    setTargetApplications() {
      if (!this.localModel.target_application_enabled) {
        this.localModel.target_applications = []
      }

      this.localModel.target_applications = this.localModel.target_applications.join(
        ','
      )
    },
    setLocations() {
      if (this.localModel.locations) {
        const locations = []
        this.localModel.locations.forEach(location => {
          locations.push(location.id)
        })

        this.localModel.locations = locations
      }
    },
    setVariantProps() {
      if (!this.localModel.ab) {
        this.localModel.ab_cg = 0
        this.localModel.ab_cg_size = null
        this.localModel.ab_variants = null
      }
    },
    setLanguageProps() {
      if (!this.localModel.languages_multi) {
        this.localModel.languages_default = null
        this.localModel.languages_list = null
      }
    },
    formatModelDates() {
      if (this.localModel.persist_type === 1) {
        this.localModel.persist_for = null
        this.localModel.persist_for_period = null
      } else if (this.localModel.persist_type === 2) {
        this.localModel.persist_until = null
      } else {
        this.localModel.persist_until = null
        this.localModel.persist_for = null
        this.localModel.persist_for_period = null
      }

      if (this.localModel.retry_type === 1) {
        this.localModel.retry_for = ''
        this.localModel.retry_for_period = ''
      } else if (this.localModel.retry_type === 2) {
        this.localModel.retry_for = ''
        this.localModel.retry_for_period = ''
        this.localModel.retry_until = ''
      } else {
        this.localModel.retry_until = ''
      }

      // convert js timestamp (ms) to php timestamp (s)
      if (this.localModel.persist_until) {
        this.localModel.persist_until = Math.round(
          this.localModel.persist_until / 1000
        )
      }

      if (this.localModel.retry_until) {
        this.localModel.retry_until = Math.round(
          this.localModel.retry_until / 1000
        )
      }
    },
    checkEventsData() {
      if (!this.localModel.event_limit_per_user) {
        this.localModel.event_limit_per_user = ''
      }
    },
    saveRecentlyViewedCampaign(id) {
      window.parent.postMessage(
        {
          type: 'recently_viewed_campaigns',
          id,
          action: 'add'
        },
        '*'
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/mixins/CreateCampaignMixin.js